import SVG from "../../../Components/SVG";
import Spinner from "../../../Components/Loader/Spinner";

export default function EditButton({
  isEditing = false,
  isSaving = false,
  onEdit,
  onCancel,
  onSave,
}) {
  if (!isEditing) {
    return (
      <div className="w-fit flex items-center gap-2.5">
        <button
          type="button"
          onClick={onEdit}
          onMouseDown={(e) => e.preventDefault()}
          className="group w-fit flex gap-1.5 py-1.5 px-3 rounded-full border border-zi-border-dark/50 dark:border-zi-border-light/50 hocus:border-zi-border-dark hocus:dark:border-zi-border-light"
        >
          <span className="text-xs font-normal text-zi-text-light/50 dark:text-zi-text-dark/50 group-hocus:text-zi-text-light group-hocus:dark:text-zi-text-dark">
            ویرایش
          </span>
          <SVG
            name="edit"
            classname="stroke-zi-text-light/50 dark:stroke-zi-text-dark/50 group-hocus:stroke-zi-text-light group-hocus:dark:stroke-zi-text-dark"
          />
        </button>
      </div>
    );
  }

  return (
    <div className="w-fit flex items-center gap-2.5">
      <button
        type="button"
        onClick={onCancel}
        disabled={isSaving}
        onMouseDown={(e) => e.preventDefault()}
        className="group w-fit flex gap-1.5 py-1.5 px-3 rounded-full border border-[#D71F1F] hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark disabled:cursor-not-allowed disabled:opacity-60"
      >
        <span className="text-xs font-normal text-[#D71F1F]">لغو</span>
        <SVG name="close" classname="stroke-[#D71F1F]" />
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={isSaving}
        onMouseDown={(e) => e.preventDefault()}
        className={`group w-fit min-w-16 flex justify-center gap-1.5 py-1.5 px-3 rounded-full border border-[#15A946] hocus:bg-zi-bg1-light hocus:dark:bg-zi-bg1-dark disabled:cursor-wait disabled:opacity-80`}
      >
        
        {isSaving ? (
          <div className="flex justify-center items-center px-[16.525px]">
          <Spinner size={18} color="#15A946" stroke={2} />
          </div>
        ) : (
          <>
            <span className="text-xs font-normal text-[#15A946]">ذخیره</span>
            <SVG name="check" classname="stroke-[#15A946]" />
          </>
        )}
      </button>
    </div>
  );
}
